import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useIntl } from 'react-intl';
import colors from '../../config/theme/colors';

const ACSearch = ({
  acOptions,
  filterValue,
  setFilter,
  width,
  onChangeEffect,
  optionLocalizationFunction,
  textFieldPlaceholder,
}: IOwnProps): React.JSX.Element => {
  const [value, setValue] = React.useState<string[]>(filterValue ? filterValue : []);

  const intl = useIntl();
  const fm = (id: string) => intl.formatMessage({ id });

  return (
    <Autocomplete
      value={value}
      onChange={(_event, newValue): void => {
        onChangeEffect && onChangeEffect();
        setValue(newValue);
        setFilter(newValue);
      }}
      // inputValue={inputValue}
      // onInputChange={(_event, newInputValue): void => {
      //   setInputValue(newInputValue);
      // }}
      multiple
      options={acOptions}
      noOptionsText={fm('general.noOptions')}
      groupBy={() => fm('examination.selectOneOrMore')}
      disableCloseOnSelect
      renderInput={params => {
        const text =
          typeof params.inputProps.value === 'string' && optionLocalizationFunction
            ? optionLocalizationFunction(params.inputProps.value)
            : params.inputProps.value;
        return (
          <div ref={params.InputProps.ref}>
            <TextField
              style={{ width: `${width || 30}rem`, padding: 0, margin: 0 }}
              disabled={params.disabled}
              id={params.id}
              fullWidth={params.fullWidth}
              label={textFieldPlaceholder ? fm(textFieldPlaceholder) : fm('general.filter')}
              slotProps={{ input: params.InputProps, htmlInput: { ...params.inputProps, value: text } }}
            />
          </div>
        );
      }}
      renderOption={({ key, ...p }: React.HTMLAttributes<HTMLLIElement> & { key: React.Key }, o): React.ReactNode => {
        const text = optionLocalizationFunction ? optionLocalizationFunction(o) : o;
        return (
          <li
            key={key}
            {...p}
            style={{
              backgroundColor: p['aria-selected'] ? colors.primary : undefined,
              color: p['aria-selected'] ? colors.white : undefined,
            }}
          >
            {text}
          </li>
        );
      }}
    />
  );
};
interface IOwnProps {
  /** All allowed options for auto complete. */
  acOptions: Array<string>;
  /** Values currently set in the filter */
  filterValue?: Array<string>;
  /** A React "set state" hook which updates a filtering string used elsewhere. */
  setFilter: React.Dispatch<React.SetStateAction<string[]>>;
  /** Width of the input field in rem. */
  width?: number;
  /** Addition callback for value onChange event. */
  onChangeEffect?: () => void;
  /** Function to localize options */
  optionLocalizationFunction?: (option: string) => string;
  /** Text field placeholder localeid */
  textFieldPlaceholder?: string;
}

/**
 * Autocomplete component similar to `InputHandler/components/AutoCompleteSelect.tsx`
 * but not for submitting to form. This component only renders an autocompleted drop
 * down input field and updates some search string using a hook it receives in props.
 */
export default ACSearch;
